import { render, staticRenderFns } from "./SelectedSinistersSummary.vue?vue&type=template&id=0f8ed9c0"
import script from "./SelectedSinistersSummary.vue?vue&type=script&lang=js"
export * from "./SelectedSinistersSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/SelectedSinistersSummary.vue
// module id = 707
// module chunks = 31